export default "__VITE_ASSET__CURRCahQ__"